import { render, staticRenderFns } from "./Necklaces.vue?vue&type=template&id=5f042961&"
import script from "./Necklaces.vue?vue&type=script&lang=js&"
export * from "./Necklaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports